export class AppConstants {
  public static readonly LastUrlKeyName = 'eaLastUrl';
}
